import { IScheduleBlock } from '@lifetools/shared-app-data';
import { sort } from 'utils/sort';
import { TimeSlot } from '../../types/TimeSlot';

export const sortBlocksByTimeSlots = (blocks: IScheduleBlock[], timeSlots: TimeSlot[]) => (
  sort(blocks, {
    accessor: (block: IScheduleBlock) => block.start?.toString(),
    order: timeSlots.map(timeSlot => timeSlot.time.toString()),
    sortNulls: 'bottom',
  })
);
